import React, { createContext, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [products, setProducts] = useState(null);
  const [currency, setCurrency] = useState("₦");

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        products,
        setProducts,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
export default UserContext;
